import { format, parse } from 'date-fns';
import { ISO_8601_DATE_FORMAT, SECONDS_TIMESTAMP_FORMAT } from 'constants/time-and-date';
import { shiftDateObjectByTimezone } from 'tz-offsets';

const secondsToTimeString = (time, hasLeadingZeroForMin = true) => {
  const hrs = Math.floor(time / 3600);
  const mins = Math.floor((time % 3600) / 60);
  const secs = parseInt(time % 60, 10);
  let ret = '';

  if (hrs > 0) {
    ret += `0${hrs}:`.slice(-3);
  }

  ret += hasLeadingZeroForMin ? `0${mins}:`.slice(-3) : `${mins}:`.slice(-3);
  ret += `0${secs}`.slice(-2);
  return ret;
};

export const iso8601Date = (date = new Date()) =>
  [date.getUTCFullYear(), `0${date.getUTCMonth() + 1}`.slice(-2), `0${date.getUTCDate()}`.slice(-2)].join('-');

export const parseIso8601Date = formattedDate => parse(formattedDate, ISO_8601_DATE_FORMAT, new Date());
export const parseUnixSecondsDate = formattedDate => parse(formattedDate, SECONDS_TIMESTAMP_FORMAT, new Date());

export const localDate = (dateObject = new Date()) => format(dateObject, ISO_8601_DATE_FORMAT);

export const timezoneDate = (timezone, date = new Date()) => localDate(shiftDateObjectByTimezone(date, timezone));

export default secondsToTimeString;
